import { gql } from 'apollo-angular';

import {
  CONFIGURATION_VARIABLE_FRAGMENT
} from 'graphql/fragments/configuration-variable';

export const PRODUCT_LINE_CONFIGURATION_FILTERS_FRAGMENT = gql`
  fragment ProductLineConfigurationFiltersFragment on ProductLine {
    id
    configuration {
      sectionFilters: section(id: "Filter") {
        id
        name
        showFilterProp: property(name: "showFilter") {
          valueText
        }
        sections {
          id
          name
          showFilterProp: property(name: "showFilter") {
            valueText
          }
          sections {
            id
            name
            showFilterProp: property(name: "showFilter") {
              valueText
            }
            sections {
              id
              name
              showFilterProp: property(name: "showFilter") {
                valueText
              }
              variables: filteredVariables( paging: { page: 0, perPage: 250 }, filter: { isVisible: true }) {
                items {
                  ...ConfigurationVariableFragment
                }
              }
            }
            variables: filteredVariables( paging: { page: 0, perPage: 250 }, filter: { isVisible: true }) {
              items {
                ...ConfigurationVariableFragment
              }
            }
          }
        }
      }
    }
  }
  ${CONFIGURATION_VARIABLE_FRAGMENT}
`;
